/* eslint-disable import/prefer-default-export */
export function durationToHuman(ms) {
  const seconds = Math.floor((ms / 1000) % 60);
  const minutes = Math.floor((ms / 1000 / 60) % 60);
  const hours = Math.floor(ms / 1000 / 60 / 60);

  const paddedSeconds = pad(seconds.toString(), 2);
  const paddedMinutes = pad(minutes.toString(), 2);
  let humanized;

  if (hours > 0) {
    humanized = `${hours}:${paddedMinutes}:${paddedSeconds}`;
  } else {
    humanized = `${minutes.toString()}:${paddedSeconds}`;
  }

  return humanized;
}

function pad(numberString, size) {
  let padded = numberString;
  while (padded.length < size) padded = `0${padded}`;
  return padded;
}

/**
 * Aggiunge al numero eventualmente due cifre decimali
 * I decimali li cerca come "." o "," e li converte in "."
 *
 * Es. dato 10 restituisce 10.00
 * Es. dato 10.5 restituisce 10.50
 * Es. dato 10,6 restituisce 10.60
 * Es. dato 10,64 restituisce 10.64
 *
 * @param value
 */
export function normalizeNumber(value){
    // Value deve essere una stringa. SnormalizeNumbere è un numero la converte.
    value = value.toString();
    if (value.indexOf('.') !== -1){
        let fields = value.split('.')
        return fields[0] + '.' + (fields[1] + '00').substr(0, 2)
    }
    if (value.indexOf(',') !== -1){
        let fields = value.split(',')
        return fields[0] + '.' + (fields[1] + '00').substr(0, 2)
    }
    return value + '.00';
}

export function convertNullToEmptyString(obj, excludedList = []) {
  let newobj = {}
  Object.keys(obj).map((key) => {
    if (obj[key] == null){
        if (!excludedList.includes(key))
        {
            newobj[key] = ""
        }
        else {
            newobj[key] = null
        }
    }
    else if (typeof obj[key] === 'object'){
        newobj[key] = convertNullToEmptyString(obj[key], excludedList)
    }
    else
    {
        newobj[key] = obj[key]
    }
    return 0;
  });

  return newobj;
}

export function arrayToCombo(items, keyCol, textCol, valueCol, addEmpty = true)
{
    let list = [];
    if (addEmpty === true){
      list.push({ key: '', text: '', value: ''})
    }
    items.map((item) => (
        list.push({ key: item[keyCol], text: item[textCol], value: item[valueCol] })
    ))
    return list;
}

export function arrayToComboAdd(originalList, newItem, keyCol, textCol, valueCol)
{
    if (originalList === undefined) {
        originalList = [];
    }
    // Rimuovo da originalList eventualoi elementi che hanno stessa key = newItem[keyCol]
    let newList = originalList.filter(item => item['key'] !== newItem[keyCol])
    return newList.concat({ key: newItem[keyCol], text: newItem[textCol], value: newItem[valueCol] });
}

export function storageAvailable(type) {
    try {
        let storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return false;
    }
}

export function createInstance() {
    let isStorageAvailable = storageAvailable('sessionStorage');
    return {
        save: function(id, obj) {
            if (isStorageAvailable)
            {
                sessionStorage.setItem('_isstrg_'+id, JSON.stringify(obj));
            }
        },
        restore: function(id, ctx, cbAfterSetState) {
            let value = sessionStorage.getItem('_isstrg_'+id);
            if (value !== null && ctx !== null){
                const newObject = JSON.parse(value);
                ctx.setState(newObject, cbAfterSetState);
                return newObject;
            }
            else{
                return null;
            }
        }
    }
}

export function renderElapsedString(startTime, stopTime = Date.now(), showSeconds = true) {
    if (stopTime === undefined){
        stopTime = Date.now();
    }
    else {
        stopTime = new Date(stopTime);
    }

    let startDateTime = new Date(startTime);
    let totalElapsed = stopTime - startDateTime;
    if (totalElapsed >= 0)
    {
        return millisecondsToHuman(totalElapsed, showSeconds);
    }
    else {
        return '';
    }

}

export function minutesToHuman(min, showSeconds = false){
    return millisecondsToHuman(min*60*1000, showSeconds);
}

function millisecondsToHuman(ms, showSeconds = false) {
    const seconds = Math.floor((ms / 1000) % 60);
    const minutes = Math.floor((ms / 1000 / 60) % 60);
    const hours = Math.floor(ms / 1000 / 60 / 60);

    if (showSeconds){
        return [
            pad(hours.toString(), 2),
            pad(minutes.toString(), 2),
            pad(seconds.toString(), 2),
        ].join(':');
    }
    return [
        pad(hours.toString(), 2),
        pad(minutes.toString(), 2),
    ].join(':');
}

let colorPalettes = {
    googlecharts: [
        "#3366CC",
        "#DC3912",
        "#FF9900",
        "#109618",
        "#990099",
        "#3B3EAC",
        "#0099C6",
        "#DD4477",
        "#66AA00",
        "#B82E2E",
        "#316395",
        "#994499",
        "#22AA99",
        "#AAAA11",
        "#6633CC",
        "#E67300",
        "#8B0707",
        "#329262",
        "#5574A6",
        "#3B3EAC"
    ],
    fancy: ["#bcedd8",
        "#deb1e0",
        "#98d5a0",
        "#ecabb7",
        "#2bbcce",
        "#e8b293",
        "#54d7eb",
        "#e1ca9b",
        "#62c8ea",
        "#b1bf81",
        "#86c2ee",
        "#dcecb3",
        "#adbce9",
        "#9be4c0",
        "#9adfee",
        "#b9cda1",
        "#68c8ca",
        "#90c4ad",
        "#89eee3",
        "#70d3c1"],
    colorbird: ["#593789",
        "#85a443",
        "#c35cad",
        "#50b47b",
        "#b4477b",
        "#c99738",
        "#647ed7",
        "#b55b37",
        "#b585d7",
        "#ba4758"]
};

export function getChartColors(tipo = 1){
    if (tipo === 1){
        return colorPalettes.googlecharts;
    } else if (tipo === 2){
        return colorPalettes.fancy;
    }
}

export function capitalizeFirstLetter(string) {
    return string && string.charAt(0).toUpperCase() + string.slice(1);
}


export function copiaTestoNegliAppunti(testo){
    var textField = document.createElement('textarea')
    textField.innerText = testo
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
}

export function normalizzaAttivitaGiorno(pitems){

    let L = new Array(10);
    let LC = new Array(10);
    let LM = [];

    // Ordina i pitems secondo il campo inizio
    pitems.sort(function(a,b) {
        if (a.inizio < b.inizio){
            return -1;
        }
        else if (a.inizio > b.inizio){
            return 1;
        }
        else{
            return 0;
        }
    })

    let i=0;
    L[i] = trasformaOrariInMinuti(pitems);

    do{
        let rv = completaOrari(L[i], LM);
        LC[i] = rv.LC;
        L[++i] = rv.L1;
    } while(L[i].length > 0)
    LC.length = i;
    for (let j =0; j<i; j++){
        LC[j] = normalizzaSerieDati(LC[j], LM);
    }
    return LC;
}

function trasformaOrariInMinuti(items) {
    let rv = [];
    for (let i=0; i<items.length; i++){
        if (items[i].inizio && items[i].fine){
            let giorno = new Date(items[i].giorno);
            let inizio = new Date(items[i].inizio);
            let fine = new Date(items[i].fine);
            let elapsedInizio = inizio - giorno;
            let elapsedFine = fine - giorno;
            rv.push({
                idCommessa: items[i].idCommessa,
                inizio: Math.round(elapsedInizio/(1000*60)),
                fine: Math.round(elapsedFine/(1000*60)),
                durata: Math.round(elapsedFine/(1000*60)) - Math.round(elapsedInizio/(1000*60)),
            });
        }
    }
    return rv;
}

function completaOrari(L, LM) {
    let LC = [];
    let L1 = [];

    // Se l'array passato non ha elementi ritorna subito i valori di default.
    if (L.length === 0){
        let natt = {
            key: '0'.padStart(8, "0"),
            inizio: 0,
            fine: 1440,
            durata: 1440,
        };
        LC.push(natt);
        LM[natt.key] = natt;
        return {LC, L1};
    }

    // Aggiunge il primo elemento standard
    if (L[0].inizio > 0){
        L.unshift({
            key: '0'.padStart(8, "0"),
            inizio: 0,
            fine: L[0].inizio,
            durata: L[0].inizio,
        })
    }

    let attPrec = null;
    L.forEach((attCorr) => {
        // Genera la chiave per l'attività corrente
        attCorr.key = ('' + attCorr.inizio).padStart(8, "0");
        if (attCorr.idCommessa !== undefined){
            attCorr.key += '_' + attCorr.idCommessa.codice;
        }

        if (attPrec === null){
            LC.push(attCorr);
            LM[attCorr.key] = attCorr;
            attPrec = attCorr;
        }
        else {
            let gap = attCorr.inizio - attPrec.fine;
            if (gap > 0){
                let natt = {
                    key: ('' + attPrec.fine).padStart(8, "0"),
                    inizio: attPrec.fine,
                    fine: attCorr.inizio,
                    durata: attCorr.inizio - attPrec.fine
                };
                LC.push(natt);
                LC.push(attCorr);
                LM[natt.key] = natt;
                LM[attCorr.key] = attCorr;
                attPrec = attCorr;
            } else if (gap === 0){
                LC.push(attCorr);
                LM[attCorr.key] = attCorr;
                attPrec = attCorr;
            } else if (gap < 0){
                L1.push(attCorr);
            }
        }
    });
    if (attPrec.fine < 1440){
        let natt = {
            key: ('' + attPrec.fine).padStart(8, "0"),
            inizio: attPrec.fine,
            fine: 1440,
            durata: 1440 - attPrec.fine,
        };
        LC.push(natt);
        LM[natt.key] = natt;
    }
    return {LC: LC, L1:L1};
}

function normalizzaSerieDati(LC, LM) {
    let LN = [];
    Object.keys(LM).sort().forEach((key) => {
        let natt = Object.assign({}, LM[key]);
        // Cerco att su LC. Se esiste prendo la sua durata, altrimenti aggiungo l'attività con durata 0.
        natt.durata = 0;
        let attTrovata = LC.find((item) => {
            return item.key === natt.key;
        })
        if (attTrovata !== undefined){
            natt.durata = attTrovata.durata;
        }
        LN.push(natt);
    })
    return LN;
}

export function adaptPathToOs(path){
    var regex1 = /file:\/\//gi;
    var regex2 = /\//gi;
    path = path.replace(regex1, '');
    path = path.replace(regex2, '\\');
    return path;
}


export const optionsStatoGara = [
    { key: 'IP', text: 'In preparazione', value: 'IP' },
    { key: 'CN', text: 'Consegnata con esito negativo', value: 'CN' },
    { key: 'CP', text: 'Consegnata con esito positivo', value: 'CP' },
    { key: 'CA', text: 'Consegnata in attesa di esito', value: 'CA' },
    { key: 'NC', text: 'Non consegnata', value: 'NC' },
    { key: 'EP', text: 'MdI/Elenchi/Presentazione - Consegnata', value: 'EP' },
]

export function getStatoGaraDescription(stato){
    const item = optionsStatoGara.find(value => value.key === stato);
    if (item !== undefined){
        return item.text;
    }
    return '';
}

export const optionsCommessePeso = [
    { key: '1', text: 'Normale', value: '1' },
    { key: '2', text: 'Doppio', value: '2' },
    { key: '0.5', text: 'Metà', value: '0.5' },
];

export const optionsCommesseInRendicontazione = [
    { key: '0', text: 'Esclusa da rendicontazione', value: '0' },
    { key: '1', text: 'In rendicontazione', value: '1' },
    { key: '9', text: 'Di futura rendicontazione', value: '9' },
];

export function getCommesseInRendicontazioneDescription(inRendicontazione){
    const item = optionsCommesseInRendicontazione.find(value => value.key === inRendicontazione);
    if (item !== undefined){
        return item.text;
    }
    return '';
}

export function getShortText(text, maxLength){
    if (text && text.length > maxLength){
        return text.slice(0,maxLength)+"...";
    }
    return text;
}

export const optionsStatoNews = [
    { key: '0', text: 'Tutte', value: '0' },
    { key: '1', text: 'Da leggere', value: '1' },
    { key: '2', text: 'Lette', value: '2' },
    { key: '3', text: 'Scartate', value: '3' },
    { key: '4', text: 'Archiviate', value: '4' }
]



/** WEBPACK FOOTER **
 ** ./src/Helpers.js
 **/